"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.actionTypes = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("../Button"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _LottieAnimate = _interopRequireDefault(require("../LottieAnimate"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var actionTypes = exports.actionTypes = {
  accepted: 'accepted',
  blocked: 'blocked'
};
var FirstActionDialog = function FirstActionDialog(_ref) {
  var isOpen = _ref.isOpen,
    type = _ref.type,
    onClose = _ref.onClose;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  function handleOnClose() {
    onClose(checked);
  }
  var path;
  if (type === actionTypes.accepted) {
    path = t('onmail-contact-accepted.json');
  } else if (type === actionTypes.blocked) {
    path = t('onmail-contact-blocked.json');
  }
  if (!path) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "xs",
    open: isOpen,
    onClose: handleOnClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center justify-center w-full p-8"
  }, /*#__PURE__*/_react["default"].createElement(_LottieAnimate["default"], {
    loop: true,
    path: path,
    className: "w-56 h-56"
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold mb-6"
  }, t("approveSender.firstAction.title.".concat(type))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "select-none"
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    name: "acceptContact",
    checked: checked,
    onChange: function onChange() {
      return setChecked(!checked);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm"
  }, t('approveSender.firstAction.acceptContactPrompt')))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleOnClose,
    className: "w-28 mt-2"
  }, t('button.okay'))));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FirstActionDialog);
//# sourceMappingURL=index.js.map